import React from 'react';
import { Tooltip, CircularProgress } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  HourglassEmpty as PendingIcon,
} from '@mui/icons-material';

type ExportStatusIconProps = {
  status: string;
  error?: string;
};

export const ExportStatusIcon: React.FC<ExportStatusIconProps> = ({
  status,
  error,
}) => {
  const iconProps = { fontSize: 'small' as const };

  switch (status) {
    case 'COMPLETED':
      return <CheckCircleIcon {...iconProps} color="success" />;
    case 'PROCESSING':
      return <CircularProgress size={20} color="warning" />;
    case 'PENDING':
      return <CircularProgress size={20} color="info" />;
    case 'FAILED':
      return error ? (
        <Tooltip title={error} arrow>
          <ErrorIcon {...iconProps} color="error" />
        </Tooltip>
      ) : (
        <ErrorIcon {...iconProps} color="error" />
      );
    default:
      return <PendingIcon {...iconProps} color="action" />;
  }
};
